/* src/app/main/pages/contact/finland/finland.component.css */
section {
  padding: 60px 0;
}
section .section-title {
  text-align: center;
  color: #007b5e;
  margin-bottom: 50px;
  text-transform: uppercase;
}
#tabs {
  border-top: 10px solid #213654;
}
#tabs nav {
  background: #F0F0F0;
}
#tabs .nav-tabs {
  border-bottom: none;
}
#tabs .nav-tabs .nav-link.active {
  background-color: transparent;
}
#tabs .nav-tabs .nav-item.show .nav-link,
#tabs .nav-tabs .nav-link.active {
  color: #213654;
  background-color: transparent;
  border-color: transparent transparent #f3f3f3;
  border-bottom: 3px solid #E7792B !important;
  font-size: 18px;
  font-weight: bold;
}
#tabs .nav-tabs .nav-link.active {
  position: relative;
}
#tabs .nav-tabs .nav-link.active .fa {
  display: none;
}
#tabs .nav-tabs .nav-link .fa {
  padding-right: 10px;
}
#tabs .nav-tabs .nav-link.active span {
  padding-left: 35px;
}
#tabs .nav-tabs .nav-link.active::before {
  content: "";
  position: absolute;
  background-size: 24px auto;
  left: 0;
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  margin-right: 10px;
  padding-right: 10px;
}
#nav-denmark-tab.active::before {
  background-image: url(/assets/images/icons/denmark-icon.png);
}
#nav-estonia-tab.active::before {
  background-image: url(/assets/images/icons/estonia-icon.png);
}
#nav-finland-tab.active::before {
  background-image: url(/assets/images/icons/finland-icon.png);
}
#nav-norway-tab.active::before {
  background-image: url(/assets/images/icons/norway-icon.png);
}
#nav-sweden-tab.active::before {
  background-image: url(/assets/images/icons/sweden-icon.png);
}
.nav-tabs .nav-link span {
  display: flex;
  align-items: center;
}
#tabs .nav-tabs .nav-link {
  border: 1px solid transparent;
  color: #212121;
  font-size: 18px;
  padding: 18px 0px;
  flex: 0 1 auto;
  margin-right: 50px;
  font-weight: bold;
}
#tabs .nav-tabs .nav-link img {
  width: 30px;
  padding-right: 10px;
}
#tabs .tab-content {
  padding-top: 60px;
  padding-bottom: 60px;
}
#tabs .tab-content h2 {
  font-family: "D-DIN";
  font-size: 26px;
}
#tabs .tab-content .office-loc-heading img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
#tabs .tab-content .cust-col-1 {
  color: #5F5F5F;
  font-size: 17px;
  font-weight: 500;
  padding-top: 30px;
}
#tabs .tab-content .cust-col-1 a {
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  color: #5F5F5F;
}
#tabs .tab-content .cust-col-1 a:hover {
  text-decoration: none;
}
#tabs .tab-content .cust-col-1 a .fa {
  padding-right: 15px;
  font-size: 20px;
  color: #213654;
}
p.main-addr {
  line-height: 22px;
}
.border-bottom {
  border-bottom: 1px solid #f5f5f5 !important;
}
hr.divider {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
@media (min-device-width: 1440px) {
  #tabs .nav-tabs .nav-item.show .nav-link,
  #tabs .nav-tabs .nav-link.active {
    font-size: 22px;
  }
  #tabs .nav-tabs .nav-link {
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  #tabs .nav-tabs .nav-link {
    padding: 18px 10px;
  }
  #tabs .nav-tabs .nav-link.active::before {
    background-size: 32px auto;
    width: 35px;
    height: 35px;
    margin-right: 13px;
    padding-right: 15px;
  }
  #tabs .tab-content h2 {
    font-size: 36px;
  }
  #tabs .tab-content .office-loc-heading img {
    width: 45px;
    height: 45px;
    margin-right: 10px;
  }
  #tabs .tab-content .cust-col-1 {
    font-size: 18px;
    padding-top: 40px;
  }
  p.main-addr {
    line-height: 35px;
  }
}
@media (min-device-width: 768px) and (max-device-width: 1023px) {
  #tabs .tab-content .cust-col-1 {
    color: #5F5F5F;
    font-size: 14px;
    font-weight: 500;
    padding-top: 30px;
  }
}
@media (max-device-width: 768px) {
  #tabs .nav-tabs {
    flex-wrap: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
  }
}
/*# sourceMappingURL=finland.component.css.map */
